import React from 'react';

/**
 * Shared empty list UI (inventory admin pages).
 * @param {React.ComponentType<{ size?: number; strokeWidth?: number }>} Icon - lucide-react icon
 */
export default function EmptyStateBlock({ Icon, title, description, compact = false, className = '' }) {
    const pad = compact ? 'py-8' : 'py-14';
    return (
        <div
            className={`flex flex-col items-center justify-center ${pad} px-6 mt-2 mx-auto max-w-lg rounded-2xl border border-dashed border-gray-200 bg-gradient-to-b from-slate-50/90 to-white text-center ${className}`}
            role="status"
            aria-live="polite"
        >
            <div
                className="flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-2xl bg-blue-50 text-blue-500 shadow-sm ring-1 ring-blue-100/80 mb-5"
                aria-hidden
            >
                <Icon size={40} strokeWidth={1.5} />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 tracking-tight">{title}</h3>
            <p className="mt-2 text-sm text-gray-500 max-w-md leading-relaxed">{description}</p>
        </div>
    );
}
